export function YarnDivider() {
  return (
    <div aria-hidden="true" className="relative max-w-6xl mx-auto px-6 py-2">
      <svg viewBox="0 0 1000 24" className="w-full h-6" fill="none" preserveAspectRatio="none">
        <path
          d="M0 12 C 60 2, 120 22, 180 12 S 300 2, 360 12 S 480 22, 540 12 S 660 2, 720 12 S 840 22, 900 12 S 980 6, 1000 12"
          stroke="#B79A61"
          strokeOpacity="0.55"
          strokeWidth="2"
          strokeDasharray="7 8"
          strokeLinecap="round"
        />
        <circle cx="1000" cy="12" r="4" fill="#742F40" fillOpacity="0.7" />
      </svg>
    </div>
  );
}
